// The one back link (consistency pass, R8 W5, Kristi Nov 1): "← Back to <where>", 15 px, 600,
// teal, top left, above the page's heading, wherever a page sits inside another. It names the
// place it returns to. Steps inside a flow (Import's footer Back) keep their own controls.

export function BackLink({ where, onClick, class: cls = '' }: { where: string; onClick: () => void; class?: string }) {
  return (
    <button type="button" class={`back-link${cls ? ` ${cls}` : ''}`} onClick={onClick}>
      ← Back to {where}
    </button>
  );
}
